module.exports = __webpack_public_path__ + "media/images/socials/lichess-b57d29ae00a840281511c9de99aaf1a0.png";